// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1lEz7","m-signature-pad--body":"styles__m-signature-pad--body___3pKiW","m-signature-pad--footer":"styles__m-signature-pad--footer___3LFiC","description":"styles__description___1ITPc","button":"styles__button___2949c","clear":"styles__clear___3mW6T","save":"styles__save___MBxYP","m-signature-pad":"styles__m-signature-pad___S-Qef","github":"styles__github___33Zc2","label":"styles__label___ww7ci","outcomeNote":"styles__outcomeNote___1lMBh"};


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/ContactCustomerModal/styles.scss
// module id = Rurv
// module chunks = client